import Clarity from '@microsoft/clarity';

const clarityProjectId = process.env.CLARITY_KEY?.trim();
const isClarityEnabled = Boolean(clarityProjectId);

let isClarityInitialized = false;

export const initClarity = () => {
  if (!clarityProjectId || !isClarityEnabled || isClarityInitialized) {
    return;
  }

  Clarity.init(clarityProjectId);
  Clarity.consentV2();
  isClarityInitialized = true;
};

export const identifyClarityUser = (userId?: string) => {
  if (!isClarityEnabled || !userId) {
    return;
  }

  initClarity();
  Clarity.identify(userId);
};
